angular.module('nv.components.autocomplete-floating-label', []);
